// eslint-disable-next-line jira/filename-case
import React, { useCallback, type ReactNode } from 'react';
import { NAVIGATION_SIDEBAR_MARKS } from '@jira/navigation-apps__performance-metrics/src/constants.tsx';
import { NavSidebarPerformanceMark } from '@jira/navigation-apps__performance-metrics/src/index.tsx';
import UFOLoadHold from '@atlaskit/react-ufo/load-hold';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import UFOSegment from '@atlassian/jira-ufo-segment/src/index.tsx';
import { SidebarErrorBoundary } from './common/ui/error-boundary/index.tsx';
import { useSidebarFail, useSidebarSuccess } from './controllers/metrics/main.tsx';
import { Skeleton } from './ui/skeleton/index.tsx';

export type SidebarBoundaryProps = {
	children: ReactNode;
	id: string;
};

export const SidebarBoundary = ({ children, id }: SidebarBoundaryProps): React.JSX.Element => {
	const onFail = useSidebarFail();
	const onSuccess = useSidebarSuccess();

	const onError = useCallback(
		(location: string, error: Error) => {
			// @ts-expect-error - TS2339 - Property 'statusCode' does not exist on type 'Error'.
			const { statusCode } = error;

			if (statusCode != null && statusCode >= 400 && statusCode < 500) {
				onSuccess();
			} else {
				onFail(location, error);
			}
		},
		[onFail, onSuccess],
	);

	return (
		<SidebarErrorBoundary id={id} packageName="jiraSpaAppsSidebarCommon" onError={onError}>
			<NavSidebarPerformanceMark metricKey={NAVIGATION_SIDEBAR_MARKS.renderAttempt} />
			<UFOSegment name="nav-sidebar">
				<Placeholder
					name="nav-sidebar"
					fallback={
						<UFOLoadHold name="nav-sidebar-loading">
							<Skeleton isFull />
						</UFOLoadHold>
					}
				>
					{children}
				</Placeholder>
			</UFOSegment>
		</SidebarErrorBoundary>
	);
};
